import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { WebinarsData } from './types'
import { WebinarsService } from './WebinarsService'

const initialState: WebinarsData = {
  upcomingWebinars: [],
  pastWebinars: [],
  selectedWebinar: undefined,
}

export const fetchWebinars = createAsyncThunk('webinars/fetchWebinars', async () => {
  try {
    const { data } = await WebinarsService.fetchWebinars()
    return data
  } catch (error) {
    throw Error(error.message)
  }
})

export const fetchWebinarById = createAsyncThunk(
  'webinars/fetchWebinarById',
  async (id: number) => {
    try {
      const { data } = await WebinarsService.fetchWebinarById(id)
      return data
    } catch (error) {
      throw Error(error.message)
    }
  },
)

const WebinarsSlice = createSlice({
  name: 'Webinars',
  initialState,
  reducers: {
    clearSelectedWebinar: (state) => {
      state.selectedWebinar = undefined
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWebinars.fulfilled, (state, action) => {
      state.upcomingWebinars = action.payload.upcomingWebinars
      state.pastWebinars = action.payload.pastWebinars
    })
    builder.addCase(fetchWebinarById.fulfilled, (state, action) => {
      state.selectedWebinar = action.payload
    })
  },
})

const WebinarsReducer = WebinarsSlice.reducer
export const { clearSelectedWebinar } = WebinarsSlice.actions
export default WebinarsReducer
